import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as Yup from 'yup';

export const signupValScheme = Yup.object({
    firstName: Yup.string().required(
        <FormattedMessage id="NewPartnersPage.Setup.Account.firstName.errMsg" />
    ),
    lastName: Yup.string().required(
        <FormattedMessage id="NewPartnersPage.Setup.Account.lastName.errMsg" />
    ),
    email: Yup.string()
        .email(<FormattedMessage id="NewPartnersPage.Setup.Account.emailInv.errMsg" />)
        .required(<FormattedMessage id="NewPartnersPage.Setup.Account.emailReq.errMsg" />),
    password: Yup.string()
        .min(8, <FormattedMessage id="NewPartnersPage.Setup.Account.pwd.errMinMsg" />)
        .required(<FormattedMessage id="NewPartnersPage.Setup.Account.pwd.errMsg" />),

    referer: Yup.string().required('Referer is required'),
    planTarget: Yup.string().required('Plan subscription beneficiary is required'),
    organizationName: Yup.string().when(['planTarget', 'isAuthenticated'], {
        is: (planTarget, isAuthenticated) => planTarget === 'empresa' && isAuthenticated,
        then: Yup.string().required('Organization name is required'),
    }),
    addressLine1: Yup.string().when(['planTarget', 'isAuthenticated'], {
        is: (planTarget, isAuthenticated) => planTarget === 'empresa' && isAuthenticated,
        then: Yup.string().required('Address is required'),
    }),
    taxCountry: Yup.string().when(['planTarget', 'isAuthenticated'], {
        is: (planTarget, isAuthenticated) => planTarget === 'empresa' && isAuthenticated,
        then: Yup.string().required('Tax country is required'),
    }),
    taxIdType: Yup.string().when(['planTarget', 'isAuthenticated'], {
        is: (planTarget, isAuthenticated) => planTarget === 'empresa' && isAuthenticated,
        then: Yup.string().required('Tax ID type is required'),
    }),
    taxId: Yup.string().when(['planTarget', 'isAuthenticated'], {
        is: (planTarget, isAuthenticated) => planTarget === 'empresa' && isAuthenticated,
        then: Yup.string().required('Tax ID is required'),
    }),
});
